export enum TrafficSourceCodeEnum {
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Snapchat = 'SNAPCHAT',
  Other = 'OTHER',
}
